import React, { useEffect, useState } from 'react';

/**
 * SuspenseFallback - Simple loading component for React Suspense boundaries
 * Displays during lazy component loading with minimal, professional styling
 */
const SuspenseFallback: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Delay visibility to avoid flash for fast loads
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-background transition-opacity duration-300"
      style={{ opacity: isVisible ? 1 : 0 }}
    >
      <img
        src={`${import.meta.env.BASE_URL}assets/images/logo/sscottlogo.png`}
        alt="Loading..."
        className="h-12 w-auto"
      />
    </div>
  );
};

export default SuspenseFallback;

